<template>
  <div>
    <section class="cabinet">
      <app-loading :is-loading="isLoading" />
      <div class="container-fluide">
        <div class="row">
          <div class="col-12">
            <div class="purchases__title-wrapper">
              <h2 class="purchases__subtitle">
                Партнёрская интернет-площадка Unistroy
              </h2>
              <PurchasesHeading heading="Избранные закупки" />
            </div>
            <div class="purchases__list">
              <PageListTable>
                <template #before-table>
                  <colgroup>
                    <col width="5%">
                    <col width="5%">
                    <col width="7%">
                    <col width="33%">
                    <col width="14%">
                    <col width="18%">
                    <col width="8%">
                    <col width="1%">
                  </colgroup>
                </template>
              </PageListTable>
            </div>
            <Pagination
              v-if="pageCount > 1"
              :pages="pageCount"
              :current-page="page"
              :is-loading="isLoading"
              @clickPage="clickPage"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapActions } from 'vuex';
import { scrollToHeader } from '@/utils/helpers';

import loadListMixin from '@/mixins/loadListMixin';

import PurchasesHeading from '@/components/blocks/PageListHeading.vue';
import PageListTable from '@/components/blocks/PageListTable.vue';
import Pagination from '@/components/elements/Pagination.vue';

export default defineComponent({
  name: 'FavoritePurchasesPage',
  components: { PurchasesHeading, PageListTable, Pagination },
  computed: {
    ...mapState({
      pageCount: (state) => state.lots.list.pageCount,
      page: (state) => state.lots.list.page,
      isLoading: (state) => state.lots.isLoading,
    }),
  },
  methods: {
    ...mapActions('lots', ['setPage']),
    async clickPage(page) {
      await this.setPage(page);
    },
  },
});
</script>
